import { j as o } from "./AccesRecoveryIcon-CUPieIxT.js";
const n = () => /* @__PURE__ */ o.jsx("svg", { viewBox: "0 0 18 18", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ o.jsx(
  "path",
  {
    d: "m11.434.6 2.404 2.404-3.024 3.024 1.491 1.491 3.024-3.024L17.734 6.9V.6zm-4.2 0h-6.3v6.3l2.404-2.405L8.284 9.43v7.97h2.1V8.57L4.829 3.003z",
    fill: "currentColor"
  }
) });
export {
  n as I
};
